import { Container, Grid } from "@mui/material";
import { useTranslation } from "react-i18next";

//import general components
import Footer from "../../components/common/footer/footer";
import BaseTitle from "../../components/common/base-title/base-title";

//import view components
import ContactUsInformation from "../../components/view/contact-us-information/contact-us-information";

//import styles
import "./contact-us.scss";

//import image
import contactUsHeaderImage from "../../../src/assets/imgs/contact-us-header.png";
import contactUsHeaderMobileImage from "../../../src/assets/imgs/contact-us-header-mobile.png";

//import constant
import { IS_MOBILE } from "../../constants/breakpoints";

function ContactUs() {
    //general variables
    const { t } = useTranslation();

    return (
        <>
            <div className="contact-us__header">
                {IS_MOBILE ? (
                    <img src={contactUsHeaderMobileImage} alt="contact us mobile header" />
                ) : (
                    <img src={contactUsHeaderImage} alt="contact us header" />
                )}

                <div className="contact-us__header-text">{t("Messages.Contact Message")}</div>
            </div>

            <Grid className="contact-us" mt={{ xs: 1, md: 2 }} mb={16}>
                <Container maxWidth="xl">
                    <Grid container rowGap={{ xs: 1, md: 3 }} mb={5}>
                        <BaseTitle title={t("contactUs")} dividerColor="1px solid var(--medium-gray-color)" />
                        <ContactUsInformation />
                    </Grid>
                </Container>
            </Grid>
            <Footer />
        </>
    );
}
export default ContactUs;
